import React from "react";

const DocumentProcessingStatus = ({ docs_status }) => {
  if (!docs_status || docs_status.total === 0) {
    return null;
  }

  // Calculate total processing documents (initiated + confirmed + processing)
  const processingCount = (docs_status.initiated || 0) + 
                         (docs_status.confirmed || 0) + 
                         (docs_status.processing || 0);

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-6 shadow-sm">
      <div className="flex items-center gap-3">
        <div className="flex-shrink-0">
          <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <div className="flex-1">
          <div className="text-xs text-gray-700 space-y-0.5">
            {docs_status.completed > 0 && (
              <p>
                <span className="font-bold text-emerald-700">{docs_status.completed}</span> {docs_status.completed === 1 ? 'document has' : 'documents have'} completed processing.
              </p>
            )}
            {processingCount > 0 && (
              <p>
                <span className="font-bold text-blue-700">{processingCount}</span> {processingCount === 1 ? 'document is' : 'documents are'} processing.
              </p>
            )}
            {docs_status.failed > 0 && (
              <p>
                <span className="font-bold text-red-700">{docs_status.failed}</span> {docs_status.failed === 1 ? 'document has' : 'documents have'} failed.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentProcessingStatus;
